import { Stack } from '@mui/material'
import { pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { HistoricList, PublishDialog } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useListHistory } from '@/hooks'
import {
  useGetCustomComponent,
  useUpdateCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import { storeKey } from '@/screens/ComponentLibrary/hooks/CONSTANTS'

import { DataIntakeSettings } from '../types'
import { parseDataIntake } from './ConfigData'

export const History = () => {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const queryKey = [storeKey, componentID, 'history']
  const historyQuery = useListHistory(
    queryKey,
    'customComponent',
    { id: componentID },
    parseDataIntake
  )
  const current = useGetCustomComponent<DataIntakeSettings>(componentID)
  const update = useUpdateCustomComponent<DataIntakeSettings>(componentID)
  const parseData = (data?: object | null) => {
    if (!data) return {}
    //@ts-ignore
    return pick(['name', 'description', 'settings', 'type'], data)
  }
  const restoreVersion = async (data: Record<string, unknown>) => {
    const restoredData = parseData(data)
    if (!restoredData) return
    await update.mutateAsync(restoredData)
  }
  return (
    <Stack height="70vh">
      <HistoricList data={historyQuery.data} restore={restoreVersion} />
      <PublishDialog
        dataToSave={parseData(current.data)}
        extraInfo={{
          customComponentHistoryId: componentID,
          organizationHistoryId: orgID,
        }}
        queryKey={queryKey}
      />
    </Stack>
  )
}
